<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="size"
    :height="size"
    viewBox="0 0 17 17"
  >
    <g>
      <g>
        <g>
          <path
            :fill="color"
            d="M15.667 14.984c0 .386-.314.7-.7.7H2.35a.702.702 0 0 1-.7-.7V2.368c0-.387.314-.701.7-.701h12.616c.387 0 .701.314.701.7zm-.7-14.018H2.35c-.773 0-1.402.628-1.402 1.402v12.616c0 .773.63 1.402 1.402 1.402h12.616c.773 0 1.402-.63 1.402-1.402V2.368c0-.774-.629-1.402-1.402-1.402z"
          />
        </g>
        <g>
          <path
            fill="none"
            :stroke="color"
            stroke-miterlimit="20"
            stroke-width="0.4"
            d="M15.667 14.984c0 .386-.314.7-.7.7H2.35a.702.702 0 0 1-.7-.7V2.368c0-.387.314-.701.7-.701h12.616c.387 0 .701.314.701.7zm-.7-14.018H2.35c-.773 0-1.402.628-1.402 1.402v12.616c0 .773.63 1.402 1.402 1.402h12.616c.773 0 1.402-.63 1.402-1.402V2.368c0-.774-.629-1.402-1.402-1.402z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            :fill="color"
            d="M9.36 7.975H7.956v-.701H9.36zm.35-1.402h-.701V3.419a.35.35 0 1 0-.701 0v3.154h-.701a.35.35 0 0 0-.35.35v1.402c0 .194.156.35.35.35h.7v1.052a.35.35 0 1 0 .702 0V8.676h.7a.35.35 0 0 0 .351-.35V6.922a.35.35 0 0 0-.35-.35z"
          />
        </g>
        <g>
          <path
            fill="none"
            :stroke="color"
            stroke-miterlimit="20"
            stroke-width="0.4"
            d="M9.36 7.975H7.956v-.701H9.36zm.35-1.402h-.701V3.419a.35.35 0 1 0-.701 0v3.154h-.701a.35.35 0 0 0-.35.35v1.402c0 .194.156.35.35.35h.7v1.052a.35.35 0 1 0 .702 0V8.676h.7a.35.35 0 0 0 .351-.35V6.922a.35.35 0 0 0-.35-.35z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            :fill="color"
            d="M13.565 7.274h-1.402v-.701h1.402zm.35-1.402h-.7V3.42a.35.35 0 1 0-.702 0v2.453h-.7a.35.35 0 0 0-.351.35v1.402c0 .194.157.35.35.35h.701v1.753a.35.35 0 1 0 .701 0V7.975h.701a.35.35 0 0 0 .35-.35V6.222a.35.35 0 0 0-.35-.35z"
          />
        </g>
        <g>
          <path
            fill="none"
            :stroke="color"
            stroke-miterlimit="20"
            stroke-width="0.4"
            d="M13.565 7.274h-1.402v-.701h1.402zm.35-1.402h-.7V3.42a.35.35 0 1 0-.702 0v2.453h-.7a.35.35 0 0 0-.351.35v1.402c0 .194.157.35.35.35h.701v1.753a.35.35 0 1 0 .701 0V7.975h.701a.35.35 0 0 0 .35-.35V6.222a.35.35 0 0 0-.35-.35z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            :fill="color"
            d="M5.154 5.872H3.752v-.7h1.402zm.35-1.402h-.7V3.42a.35.35 0 1 0-.701 0V4.47h-.701a.35.35 0 0 0-.35.35v1.403c0 .193.156.35.35.35h.7v3.154a.35.35 0 1 0 .701 0V6.573h.701a.35.35 0 0 0 .35-.35V4.82a.35.35 0 0 0-.35-.35z"
          />
        </g>
        <g>
          <path
            fill="none"
            :stroke="color"
            stroke-miterlimit="20"
            stroke-width="0.4"
            d="M5.154 5.872H3.752v-.7h1.402zm.35-1.402h-.7V3.42a.35.35 0 1 0-.701 0V4.47h-.701a.35.35 0 0 0-.35.35v1.403c0 .193.156.35.35.35h.7v3.154a.35.35 0 1 0 .701 0V6.573h.701a.35.35 0 0 0 .35-.35V4.82a.35.35 0 0 0-.35-.35z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            :fill="color"
            d="M8.658 13.582a.702.702 0 0 1 0-1.402.702.702 0 0 1 0 1.402zm0-2.103c-.773 0-1.401.629-1.401 1.402 0 .773.628 1.402 1.401 1.402s1.402-.629 1.402-1.402c0-.773-.629-1.402-1.402-1.402z"
          />
        </g>
        <g>
          <path
            fill="none"
            :stroke="color"
            stroke-miterlimit="20"
            stroke-width="0.4"
            d="M8.658 13.582a.702.702 0 0 1 0-1.402.702.702 0 0 1 0 1.402zm0-2.103c-.773 0-1.401.629-1.401 1.402 0 .773.628 1.402 1.401 1.402s1.402-.629 1.402-1.402c0-.773-.629-1.402-1.402-1.402z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            :fill="color"
            d="M4.453 13.582a.702.702 0 0 1 0-1.402.702.702 0 0 1 0 1.402zm0-2.103c-.773 0-1.402.629-1.402 1.402 0 .773.629 1.402 1.402 1.402.773 0 1.402-.629 1.402-1.402 0-.773-.629-1.402-1.402-1.402z"
          />
        </g>
        <g>
          <path
            fill="none"
            :stroke="color"
            stroke-miterlimit="20"
            stroke-width="0.4"
            d="M4.453 13.582a.702.702 0 0 1 0-1.402.702.702 0 0 1 0 1.402zm0-2.103c-.773 0-1.402.629-1.402 1.402 0 .773.629 1.402 1.402 1.402.773 0 1.402-.629 1.402-1.402 0-.773-.629-1.402-1.402-1.402z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            :fill="color"
            d="M12.864 13.582a.702.702 0 0 1 0-1.402.702.702 0 0 1 0 1.402zm0-2.103c-.773 0-1.402.629-1.402 1.402 0 .773.629 1.402 1.402 1.402.773 0 1.401-.629 1.401-1.402 0-.773-.628-1.402-1.401-1.402z"
          />
        </g>
        <g>
          <path
            fill="none"
            :stroke="color"
            stroke-miterlimit="20"
            stroke-width="0.4"
            d="M12.864 13.582a.702.702 0 0 1 0-1.402.702.702 0 0 1 0 1.402zm0-2.103c-.773 0-1.402.629-1.402 1.402 0 .773.629 1.402 1.402 1.402.773 0 1.401-.629 1.401-1.402 0-.773-.628-1.402-1.401-1.402z"
          />
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '#B2A8C1',
    },
    size: {
      type: Number,
      default: 17,
    },
  },
};
</script>
